/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberDinghyBooking', MemberDinghyBooking);

    MemberDinghyBooking.$inject = ['$resource'];

    function MemberDinghyBooking ($resource) {
        var resourceUrl =  'api/member/dinghy-bookings';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                    }
                    return data;
                }
            }
        });
    }
})();
